import React, { useState } from "react"
import { Redirect, useHistory } from 'react-router-dom'
import {
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Grid,
  Typography,
  IconButton,
  Button,
  LinearProgress
} from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import {
  Show,
  SimpleShowLayout,
  ReferenceManyField,
  useShowController,
  usePermissions,
  useRedirect
} from 'react-admin'
import { BASE_URL } from '../../../providers/dataProvider'
import PermissionsTable from './PermissionsTable'
import EditIcon from '@material-ui/icons/Edit'

const canWrite = (permissions) => {
  if (!permissions) {
    return false
  }

  if (!permissions['admin']) {
    return false
  }

  if (!permissions['admin/staff']) {
    return false
  }

  return permissions['admin/staff']['write']
}

const checkPermissions = (permissions, redirect) => {
  if (!permissions) {
    return
  }

  if ((permissions['admin'] || false) === false) {
    redirect('/forbidden')
  }

  if ((permissions['admin/staff'] || false) === false) {
    redirect('/forbidden')
  }
}

const StaffHeader = ({ record, permissions, goBack, setRoute }) => {
  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <IconButton onClick={() => goBack()}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h6" component="h6">Datos usuario</Typography>
      </div>

      {
        canWrite(permissions) && (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Button
              onClick={() => { setRoute(`/admin/staff/${record.id}/edit`) }}
              startIcon={<EditIcon />}
              color="primary"
            >
              Editar
            </Button>
          </div>
        )
      }
    </Grid>
  )
}

const StaffDataTable = ({ record }) => {
  return (
    <TableContainer style={{ marginTop: '1em' }}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell><b>Nombre</b></TableCell>
            <TableCell>{record.firstname}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell><b>Apellido</b></TableCell>
            <TableCell>{record.lastname}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell><b>Nombre de Usuario</b></TableCell>
            <TableCell>{record.username}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell><b>Rut</b></TableCell>
            <TableCell>{record.identification}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell><b>Email</b></TableCell>
            <TableCell>{record.email || '--'}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell><b>Administrador</b></TableCell>
            <TableCell>{record.isadmin ? 'SI' : 'NO'}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell><b>Habilitado</b></TableCell>
            <TableCell>{record.active ? 'SI' : 'NO'}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell><b>Fecha/Hora Creacion</b></TableCell>
            <TableCell>{new Date(record.createdat).toLocaleDateString()}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell><b>Fecha/Hora Ultima Modificacion</b></TableCell>
            <TableCell>{record.updatedat ? new Date(record.updatedat).toLocaleDateString() : '--'}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}

const StaffPermissionsSection = ({ record, permissions, setRoute }) => {
  return (
    <React.Fragment>
      <Grid
        style={{ marginBottom: '1em', marginTop: '2em' }}
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h6" component="h6">Permisos</Typography>

        {
          (record.isadmin === false && canWrite(permissions)) && (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Button
                onClick={() => { setRoute(`/admin/staff/${record.id}/permissions/edit`) }}
                startIcon={<EditIcon />}
                color="primary"
              >
                Editar
              </Button>
            </div>
          )
        }
      </Grid>

      <TableContainer>
        <ReferenceManyField
          record={record}
          basePath={BASE_URL}
          source="id"
          reference="auth/users_permissions"
          sort={{ field: 'id', order: 'DESC' }}
          perPage={100}
          target="userid"
        >
          <PermissionsTable isAdmin={record.isadmin} />
        </ReferenceManyField>
      </TableContainer>
    </React.Fragment>
  )
}

const StaffRouteRedirect = ({ route }) => {
  return route ? <Redirect to={route} /> : null
}

const StaffShow = (props) => {
  const { permissions } = usePermissions()
  const redirect = useRedirect()
  const id = props.match.params.id

  checkPermissions(permissions, redirect)

  const { record, loaded } = useShowController({
    basePath: BASE_URL,
    resource: 'auth/users',
    id
  })

  const { goBack } = useHistory()
  const [route, setRoute] = useState(null)
  if (!record || !loaded) {
    return <LinearProgress />
  }

  return (
    <Show
      title={`${record.firstname} ${record.lastname}`}
      basePath={BASE_URL}
      resource="auth/users"
      id={id}
    >
      <SimpleShowLayout>
        <StaffHeader
          record={record}
          permissions={permissions}
          goBack={goBack}
          setRoute={setRoute}
        />

        <StaffDataTable record={record} />

        <StaffPermissionsSection
          record={record}
          permissions={permissions}
          setRoute={setRoute}
        />

        <StaffRouteRedirect route={route} />
      </SimpleShowLayout>
    </Show>
  )
}

export default StaffShow